import { pageContext } from './page_context';

/**
 * Provides some handy breakpoint specific utility functions
 */
class BreakpointUtil {

    constructor() {
        // "private" function to get breakpoint from page context
        const getBreakpoint = () => pageContext.getProps().pageState.breakpoint;

        return {
            is: (breakpoint) => breakpoint === getBreakpoint(),
            isNot: (breakpoint) => breakpoint !== getBreakpoint(),
            isOneOf: (breakpoints) => breakpoints.includes(getBreakpoint())
        };
    }

}

export const breakpointUtil = new BreakpointUtil();
